/** Marks an element focused without the ring or its tooltip. Removed when focus leaves. */
export const QUIET_FOCUS_ATTR = "data-quiet-focus";

/**
 * Focus handed back to what opened a closing layer (a viewer, a side pane)
 * shows neither the ring nor the opener's tooltip. Closing with Escape makes
 * the browser treat the return as a keyboard move (:focus-visible), so the
 * opener looked framed and its tooltip popped up after the layer closed. Set
 * the mark before focusing, in the same task, so nothing flashes.
 */
export function quietFocus(el: Element) {
  el.setAttribute(QUIET_FOCUS_ATTR, "");
  el.addEventListener("blur", () => el.removeAttribute(QUIET_FOCUS_ATTR), {
    once: true,
  });
}
